// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".azati-vwc-form-alert{background-color:#fff5f5;padding:14px 20px 14px 15px;border-left:5px solid red;margin-right:15px}.azati-vwc-form-alert p.message-text{font-family:Poppins,Verdana,sans-serif;font-size:14px;color:#6e6e6e;margin-left:7px;margin:0}.azati-vwc-form-alert p.message-text:hover{cursor:pointer}.azati-vwc-form-alert p.message-text a{text-decoration:none}", ""]);
// Exports
module.exports = exports;
